@if (isAuthenticated || !isOnline) {
  <div>
    <app-navbar></app-navbar>
    <app-import-quotes-and-orders></app-import-quotes-and-orders>
    @if (shouldDisplayOfflineTimer) {
      <div id="offlineProgress" class="offline-progress-bar">
        <app-offline-progress-bar></app-offline-progress-bar>
      </div>
    }
  </div>
}

<div *appIsDesktop>
  @if (isAuthenticated || !isOnline || isOnlineWithoutInternet) {
    <div
      class="isc-component-container"
      [ngClass]="{'isc-component-container-with-progressBar': shouldDisplayOfflineTimer}">
      <router-outlet></router-outlet>
    </div>
  }
</div>

<div *appIsMobile class="isc-component-container-mobile">
  <router-outlet></router-outlet>
</div>
